import { postAPIWithRethrow } from "../../../utils/apiService";

export const switchTenantUserWithRethrow = async (body: $TSFixMe) =>
  // // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  await postAPIWithRethrow("/switch", body);
